import api from '../../api';

export default {
  name: 'accountComms',
  component() {
    return {
      formData: {
        acceptsMarketing: null
      },
      originalFormData: {
        acceptsMarketing: null
      },
      initialLoading: true,
      loading: false,
      success: false,
      error: null,
      isUpdated: false,
      customerId: null,

      get hasChanges() {
        return this.formData.acceptsMarketing !== this.originalFormData.acceptsMarketing;
      },

      init() {
        // Initialize with Liquid customer data instead of API call
        const customerAcceptsMarketing = this.$el.dataset.customerAcceptsMarketing === 'true';
        
        this.formData.acceptsMarketing = customerAcceptsMarketing;
        this.originalFormData.acceptsMarketing = customerAcceptsMarketing;
        this.initialLoading = false;
      },

      handleRadioChange(value) {
        const newValue = value === 'true';
        this.formData.acceptsMarketing = newValue;
        this.isUpdated = this.originalFormData.acceptsMarketing !== newValue;
        this.success = false;
        this.error = null;
      },

      async handleSubmit(event) {
        event.preventDefault();
        
        if (this.formData.acceptsMarketing === null || !this.hasChanges) {
          return;
        }

        this.loading = true;
        this.error = null;
        this.success = false;

        try {
          const accessToken = localStorage.getItem('accessToken');
          if (!accessToken) {
            throw new Error('Please log in to update your preferences');
          }

          const CUSTOMER_UPDATE_MUTATION = `
            mutation customerUpdate($customerAccessToken: String!, $customer: CustomerUpdateInput!) {
              customerUpdate(customerAccessToken: $customerAccessToken, customer: $customer) {
                customer {
                  id
                  acceptsMarketing
                  email
                }
                customerUserErrors {
                  code
                  field
                  message
                }
              }
            }
          `;

          const response = await fetch('/api/2024-07/graphql.json', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': api.getStorefrontToken(),
            },
            body: JSON.stringify({
              query: CUSTOMER_UPDATE_MUTATION,
              variables: {
                customerAccessToken: accessToken,
                customer: {
                  acceptsMarketing: this.formData.acceptsMarketing
                },
              },
            }),
          });

          const responseData = await response.json();

          if (responseData.errors) {
            throw new Error(responseData.errors[0].message);
          }

          const userErrors = responseData.data.customerUpdate.customerUserErrors;
          if (userErrors.length > 0) {
            throw new Error(userErrors[0].message);
          }

          this.success = true;
          this.originalFormData.acceptsMarketing = this.formData.acceptsMarketing;
          this.isUpdated = false;

          setTimeout(() => {
            this.success = false;
          }, 3000);

        } catch (err) {
          this.error = err.message;
        } finally {
          this.loading = false;
        }
      }
    };
  }
};